import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FiltersService } from "src/app/shared/services/filters.service";

@Component({
  selector: "app-search-field",
  templateUrl: "./search-field.component.html",
})
export class SearchFieldComponent implements OnInit {
  @Input() filterOptions: any | null;
  @Input() form: FormGroup;
  @Input() inputFormControlName: string;
  @Input() placeholder: string;
  @Output() emitSelectedOptions = new EventEmitter<any>();
  constructor(private filtersService: FiltersService) {}

  ngOnInit(): void {
    this.form.get(this.inputFormControlName)?.valueChanges.subscribe(() => {
      const controlValue = this.form.get(this.inputFormControlName)?.value;
      this.filtersService.updateMultipleQueryFilters({
        page: 1,
        [this.inputFormControlName]: controlValue,
      });
    });
  }

  saveOption(event: any) {
    this.emitSelectedOptions.emit(event);
  }
}
